module.exports = __webpack_public_path__ + "static/media/ic_password.a66f4030.svg";